import React from "react";

export default function Phone({ className, onClick, style }) {
  return (
    <svg
      width="13"
      height="23"
      viewBox="0 0 13 23"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.15877 2.0765H10.1055C11.0647 2.0765 11.8422 2.85404 11.8422 3.81319V19.7329C11.8422 20.692 11.0647 21.4695 10.1055 21.4695H3.15876C2.19962 21.4695 1.42208 20.692 1.42208 19.7329V3.81319C1.42208 2.85404 2.19962 2.0765 3.15877 2.0765ZM0.264282 3.81319C0.264282 2.21461 1.56019 0.918701 3.15877 0.918701H10.1055C11.7041 0.918701 13 2.21461 13 3.81319V19.7329C13 21.3314 11.7041 22.6273 10.1055 22.6273H3.15876C1.56018 22.6273 0.264282 21.3314 0.264282 19.7329V3.81319ZM5.60598 20.0223C5.44612 20.0223 5.31653 20.1519 5.31653 20.3117C5.31653 20.4716 5.44612 20.6012 5.60598 20.6012H8.02708C8.18694 20.6012 8.31653 20.4716 8.31653 20.3117C8.31653 20.1519 8.18694 20.0223 8.02708 20.0223H5.60598Z"
        fill="inherit"
      />
    </svg>
  );
}
